
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1598927762218",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "2962",
    "width": "200",
    "height": "200"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M935.597122 151.021583H442.014388a88.402878 88.402878 0 0 0-88.402877 88.402877v73.669065H195.223022A195.444029 195.444029 0 0 0 0 508.316547v202.589928a29.467626 29.467626 0 0 0 29.467626 29.467626h81.404316c0 2.431079-0.368345 4.862158-0.368345 7.366906a125.23741 125.23741 0 0 0 250.47482 0v-7.366906h302.779856v7.366906a125.23741 125.23741 0 0 0 250.474821 0v-7.366906h22.100719a88.402878 88.402878 0 0 0 88.402878-88.402878v-412.546763a88.402878 88.402878 0 0 0-89.139569-88.402877z m-699.856115 663.021582a66.302158 66.302158 0 1 1 66.302158-66.302158 66.302158 66.302158 0 0 1-66.302158 66.302158z m117.870504-132.604316h-11.787051a125.23741 125.23741 0 0 0-212.166906 0H58.935252v-117.870504h294.676259z m0-176.805755H58.935252a136.28777 136.28777 0 0 1 136.066762-132.604317H353.611511z m434.647482 309.410071a66.302158 66.302158 0 1 1 66.302158-66.302158 66.302158 66.302158 0 0 1-66.302158 66.302158z m176.805755-162.071942a29.467626 29.467626 0 0 1-29.467626 29.467626h-41.254676a125.23741 125.23741 0 0 0-212.166906 0H412.546763v-442.014389a29.467626 29.467626 0 0 1 29.467625-29.467625h493.582734a29.467626 29.467626 0 0 1 29.467626 29.467625z",
        "p-id": "2963"
      }
    }
  ]
})
    }
  